@if (partnerBrandName$ | async; as partnerBrandName) {
  <mat-card appearance="outlined" class="no-access-container">
    <div class="no-access-header">
      <div class="icon">
        <mat-icon>error_outline</mat-icon>
      </div>
      <div class="message">
        <h1>{{ 'FAILED_PAYMENTS.TITLE' | translate }}</h1>
        {{ 'FAILED_PAYMENTS.MESSAGE' | translate: { partnerName: partnerBrandName } }}
      </div>
    </div>
    <div class="action">
      <button mat-raised-button color="primary" (click)="showAssistanceModal()">
        {{ 'COMMON.ACTION_LABELS.CONTACT_US' | translate }}
      </button>
    </div>
  </mat-card>
}
